<div
  class="c-rollingOffers"
  theming
  themingGroup="portal"
  [themingAsset]="rollingOffersData.reward.gems ? 'rolling-offers-background-gems' : 'rolling-offers-background-coins'">
  <slotcom-navigation-button
    type="close"
    (click)="closeModal()">
  </slotcom-navigation-button>

  <div class="c-rollingOffers__container">
    <div
      class="c-rollingOffers-icon"
      theming
      themingGroup="portal"
      themingAsset="rich-club-icon"></div>
    <div class="c-rollingOffers__info">
      <div class="c-rollingOffers__text">
        <span class="text title"> {{ 'common.congratulations' | translate | uppercase }} </span>
        @if (rollingOffersData.reward && rollingOffersData.reward.credits) {
          <span class="text subtitle"> {{ 'home.modals.rolling-offers.coins.subtitle' | translate }}</span>
        } @else if (rollingOffersData.reward && rollingOffersData.reward.gems) {
          <span class="text subtitle"> {{ 'home.modals.rolling-offers.gems.subtitle' | translate }}</span>
        }

        <div class="reward-container">
          @if (rollingOffersData.reward) {
            <div
              class="reward-container-bg"
              theming
              themingGroup="portal"
              [themingAsset]="rollingOffersData.reward.gems ? 'box-reward-gems' : 'box-reward-coins'"
              [ngClass]="rollingOffersData.reward.gems ? 'box-reward-gems' : ''">
              <div class="reward-display-container">
                @if (rollingOffersData.reward.credits) {
                  <slotcom-display [classes]="['c-display--rolling-offers']">
                    <div
                      displayIcon
                      displayIconPos="left"
                      [ngClass]="'c-display--coin'"></div>
                    {{ rollingOffersData.reward.credits | number: '1.0-0' : ('common.culture' | translate) }}
                  </slotcom-display>
                } @else if (rollingOffersData.reward.gems) {
                  <slotcom-display [classes]="['c-display--rolling-offers']">
                    <div
                      displayIcon
                      displayIconPos="left"
                      [ngClass]="'c-display--gem'"></div>
                    {{ rollingOffersData.reward.gems | number: '1.0-0' : ('common.culture' | translate) }}
                  </slotcom-display>
                }
              </div>
            </div>
          }
        </div>
      </div>
    </div>

    <slotcom-button
      class="c-button--pink"
      (safeClick)="closeModal()"
      audioType="reward">
      <span class="label">
        {{ 'common.pick-up' | translate | uppercase }}
      </span>
    </slotcom-button>
  </div>
</div>
